import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const user = localStorage.getItem('user');
  const expiration = localStorage.getItem('session_expiration');

  if (user && expiration && Date.now() < parseInt(expiration)) {
    return true;
  } else {
    localStorage.removeItem('user');
    localStorage.removeItem('session_expiration');
    router.navigate(['/login']);
    return false;
  }
};